import moment from "moment";

import { AuditLogsFilterFormValues } from "../auditLog.types";
import {
  ACTION_FILTER_SEARCH_PARAMETER,
  ADMIN_ID_FILTER_SEARCH_PARAMETER,
  DATE_RANGE_FILTER_SEARCH_PARAMETER,
  ENTITY_ID_FILTER_SEARCH_PARAMETER,
  ENTITY_TYPE_FILTER_SEARCH_PARAMETER
} from "../constants";

export const getAuditLogsFilterNewSearchParams = ({
  adminId,
  action,
  entityType,
  entityId,
  dateRange
}: AuditLogsFilterFormValues) => {
  const newSearchParams: Record<string, string | string[]> = {};

  newSearchParams[ADMIN_ID_FILTER_SEARCH_PARAMETER] = adminId?.trim() ?? "";
  newSearchParams[ACTION_FILTER_SEARCH_PARAMETER] = action?.trim() ?? "";
  newSearchParams[ENTITY_TYPE_FILTER_SEARCH_PARAMETER] = entityType ?? "";
  newSearchParams[ENTITY_ID_FILTER_SEARCH_PARAMETER] = entityId?.trim() ?? "";

  if (Array.isArray(dateRange) && dateRange[0] && dateRange[1]) {
    // Normalize to inclusive day boundaries in ISO so the backend's
    // `dateFrom`/`dateTo` (ISO datetime, inclusive) cover the whole range.
    newSearchParams[DATE_RANGE_FILTER_SEARCH_PARAMETER] = [
      moment(dateRange[0]).startOf("day").toISOString(),
      moment(dateRange[1]).endOf("day").toISOString()
    ];
  } else {
    newSearchParams[DATE_RANGE_FILTER_SEARCH_PARAMETER] = [];
  }

  return newSearchParams;
};
